export class RequestInterceptor {
	addAuthorizationHeader (config) {
		const storage = JSON.parse(localStorage.getItem("params") || "{}");
		config.headers.Authorization = "Bearer " + (storage.token || "");
		return config;
	}
}
